import { t } from "i18next";
import Accordion from "../../AssessmentReview/Accordion/Accordion";
import {
  EssayTypeQuestion,
  MultiTypeQuestion,
  SingleTypeQuestion,
} from "ui-components";

const CustomQuestionsView = (item: any, index: any, onDeleteClick: any) => {
  switch (item?.type?.toLowerCase()) {
    case "single":
      return (
        <Accordion
          index={index}
          type={t("GENERAL.SINGLE")}
          timeLabel={t("GENERAL.TIME")}
          timeValue={`${item?.timeLimit} ${t("GENERAL.MINS")}`}
          data={item}
          isDeleteIconVisible={true}
          onDeleteClick={() => {
            onDeleteClick(item?.id);
          }}
        >
          <SingleTypeQuestion
            answerLabel={t("GENERAL.ANSWER")}
            isAccordion={true}
            data={item}
          />
        </Accordion>
      );
    case "multiple":
      return (
        <Accordion
          index={index}
          type={t("GENERAL.MULTIPLE")}
          timeLabel={t("GENERAL.TIME")}
          timeValue={`${item?.timeLimit} ${t("GENERAL.MINS")}`}
          data={item}
          isDeleteIconVisible={true}
          onDeleteClick={() => {
            onDeleteClick(item?.id);
          }}
        >
          <MultiTypeQuestion
            answerLabel={t("GENERAL.ANSWER")}
            isAccordion={true}
            data={item}
          />
        </Accordion>
      );
    case "essay":
    case "video":
      return (
        <Accordion
          index={index}
          type={t(`GENERAL.${item.type.toUpperCase()}`)}
          timeLabel={t("GENERAL.TIME")}
          timeValue={`${item?.timeLimit} ${t("GENERAL.MINS")}`}
          data={item}
          isDeleteIconVisible={true}
          onDeleteClick={() => {
            onDeleteClick(item?.id);
          }}
        >
          <EssayTypeQuestion
            answerLabel={t("GENERAL.ANSWER")}
            isAccordion={true}
            data={item}
          />
        </Accordion>
      );
    default:
      return null;
  }
};

export default CustomQuestionsView;
